import { List, ListItem, ListItemButton } from "@mui/material";
import { useEffect, useState } from "react"
import { M_SimpleTable } from "../../../../M_Components";
import "../item.css";
import { genericEntityService } from "../../../../services/genericEntityService";
import { Check } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FieldTypeEnum } from "../../../../enums/fieldTypeEnum";

export const RelationFieldItemForm = ({ entityId, fields, changeValueCallback, itemForm, isSelectable, itemId }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const [relation, setRelation] = useState(null);
    const [selectedRelation, setSelectedRelation] = useState(0);

    const selectedField = selectedRelation !== null ? fields[selectedRelation] : null;
    const idsSelected = selectedRelation !== null ? itemForm.form[selectedField.Code]?.split(",")?.map(id => Number(id)) ?? [] : [];

    const handleInputChange = (value) => {

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [selectedField?.Code]: value.map(el => el.id).join(",")
            }
        });
    }

    useEffect(() => {
        if (selectedRelation === null) {
            return;
        }

        if (!entityId || !fields[selectedRelation]?.FieldId) {
            return;
        }

        genericEntityService.getRelationItemById(entityId, fields[selectedRelation].FieldId, isSelectable || itemId === null ? null : itemId)
            .then(function (response) {
                setRelation(response.data);
            })
            .catch(function (error) { })
    }, [selectedRelation, isSelectable, itemId, entityId]);

    const fieldTypeDic = relation?.RelationFields ? relation.RelationFields?.reduce(
        (prev, cur) =>
            ({ ...prev, [cur.Code]: cur }), {}
    ) : {};

    const handleFileDownload = (filename, attachmentId) => {
        genericEntityService.getFile(attachmentId)
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(link);
            })
    }

    const columns = relation?.RelationFields ? [
        { field: 'id', header: 'Id', id: 'id' },
        ...relation.RelationFields?.filter(f => f.Type !== FieldTypeEnum.Relation).map(f => {
            return {
                field: f.Code,
                id: f.Code,
                header: <div className="relation-table-header">{f.Captions?.[currentLanguage]?.length > 0 ? f.Captions[currentLanguage] : f.Code}</div>
            }

        })
    ] : [
    ];

    const rows =
        relation?.Items ? [
            ...relation.Items.map(i => {
                const row = i.Fields ? Object.keys(i.Fields).reduce((prev, cur) => {
                    const field = fieldTypeDic[cur];
                    if (!field) {
                        return {};
                    }

                    switch (field.Type) {
                        case FieldTypeEnum.Integer:
                        case FieldTypeEnum.Currency:
                        case FieldTypeEnum.Decimal:
                            return {
                                ...prev,
                                [cur]:
                                    <div>
                                        {`${i.Fields[cur]} ${(i.Fields[cur] && field.Unit) ? field.Unit : ''}`}
                                    </div>
                            }
                        case FieldTypeEnum.Boolean:
                            return {
                                ...prev,
                                [cur]:
                                    <div>
                                        {i.Fields[cur].toLowerCase() === 'true' ? <Check></Check> : ''}
                                    </div>
                            }
                        case FieldTypeEnum.Attachment:
                            if (i.Fields[cur].length === 0) {
                                return {
                                    ...prev,
                                    [cur]: <></>
                                }
                            } else {
                                const attachment = i.Attachments[cur];
                                return {
                                    ...prev,
                                    [cur]:
                                        <div>
                                            {
                                                <a className="link" onClick={() => handleFileDownload(attachment.fileName, attachment.attachmentId)}>{attachment.fileName}</a>
                                            }
                                        </div>
                                }
                            }
                        case FieldTypeEnum.Relation:
                            return { ...prev }

                        case FieldTypeEnum.Dropdown:
                            const option = field.DropdownItems.find(d => String(d.DropdownItemId || d.dropdownItemId) === i.Fields[cur]);
                            if (!option) return { ...prev, [cur]: null }

                            const optionLanguage = option?.Captions?.[currentLanguage] ?? option?.Captions?.['en'];

                            return { ...prev, [cur]: optionLanguage }

                        default:
                            return { ...prev, [cur]: i.Fields[cur] }
                    }
                }, {}) : {};

                return {
                    id: i.ItemId,
                    ...row
                }
            })]
            :
            [];
    const selectedRows = rows.filter(el => idsSelected.includes(el.id));

    return (
        <>

            <div className="relation">
                <div className="relation-grid">
                    <div className="relation-list">
                        <div className="relation-list-title">{t("NgeSubEntities")}</div>
                        <List>
                            {
                                fields?.map((f, i) => (
                                    <ListItem key={i} disablePadding>
                                        <ListItemButton
                                            onClick={() => setSelectedRelation(i)}
                                            className={`relation-list-item ${i === selectedRelation ? 'selected' : ''}`}
                                        >
                                            <div className="text">{f?.captions?.[currentLanguage]?.length > 0 ? f.captions[currentLanguage] : f.Code}</div>
                                        </ListItemButton>
                                    </ListItem>

                                ))
                            }
                        </List>
                    </div>
                    {
                        selectedRelation !== null &&
                        <div className="relation-table">
                            <M_SimpleTable
                                header={
                                    <div className="text-title">
                                        {selectedField?.captions?.[currentLanguage]?.length > 0 ? selectedField.captions[currentLanguage] : selectedField.Code}
                                    </div>
                                }
                                rows={rows}
                                columns={columns}
                                isSelectMultiple={isSelectable}
                                selectedRows={selectedRows}
                                onSelectionChange={(e) => handleInputChange(e.value)}
                            />
                        </div>
                    }
                    {
                        selectedRelation === null &&
                        <div className="relation-table relation-empty-state">
                            <span className="text">{t("NgeNoSubEntitySelected")}</span>
                        </div>
                    }
                </div>

            </div>
        </>
    )
}
